import { connect } from 'react-redux';
import Header from '../components/Header';
import { showMobileMenu, hideMobileMenu, showHeader, hideHeader } from '../actions/ui';
import { logout } from '../actions/user';
import {isEmailVerified} from "../selectors/user";
import {isVideoInto} from "../selectors/ui";
import { isSignUpAvailable } from '../selectors/system';
import { registerPageView } from '../actions/analytics';

const mapStateToProps = state => ({
    isLogged: state.user.isLogged,
    isVerified: isEmailVerified(state),
    userData: state.user.userData,
    isHeader: state.ui.isHeader,
    isMobileMenuVisible: state.ui.isMobileMenuVisible,
    isGetMePending: state.ui.isGetMePending,
    isVideoIntro: isVideoInto(state),
    isSignUpAvailable: isSignUpAvailable(state),
});

export default connect(mapStateToProps, {
    showMobileMenu,
    hideMobileMenu,
    showHeader,
    hideHeader,
    logout,
    registerPageView,
})(Header);
